<div class="≈w-full ≈overflow-auto">
<!--    <cdk-virtual-scroll-viewport [itemSize]="itemSize">-->
        <table #table class="≈border-none ≈border-collapse ≈relative ≈w-full
                            ≈text-sm lg:≈text-base 2xl:≈text-lg ≈font-normal ≈font-apple-system">
            <ng-content>

            </ng-content>
        </table>
<!--    </cdk-virtual-scroll-viewport>-->
</div>
